import 'wc-spinners/dist/hollow-dots-spinner';

const Spinner = () => <hollow-dots-spinner />;

export default Spinner;
